// locationHelper.ts

interface AddressComponent {
    long_name: string;
    short_name: string;
    types: string[];
}

export async function getLocationDetails(): Promise<void> {
    const zipCodeInput = document.getElementById('contact-zip_code') as HTMLInputElement;
    const locationValidatedInput = document.getElementById('contact-location_validated') as HTMLInputElement;
    const cityNameInput = document.getElementById('contact-city_name') as HTMLInputElement;
    const countyNameInput = document.getElementById('contact-county_name') as HTMLInputElement;
    const stateAbbrInput = document.getElementById('contact-state_abbr') as HTMLInputElement;

    const zipcodeVal = zipCodeInput.value;

    // Reset hidden fields
    locationValidatedInput.value = 'invalid';
    cityNameInput.value = '';
    countyNameInput.value = '';
    stateAbbrInput.value = '';

    try {
        const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipcodeVal}&key=AIzaSyDvI6apULA2xlM0BDAoMm9ylCVVvuMv2KI`);

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();

        if (data.status === "OK") {
            const addressComponents: AddressComponent[] = data.results[0].address_components;
            locationValidatedInput.value = 'valid';

            addressComponents.forEach((component) => {
                switch (component.types[0]) {
                    case 'locality':
                        cityNameInput.value = component.long_name;
                        break;
                    case 'administrative_area_level_2':
                        countyNameInput.value = component.long_name;
                        break;
                    case 'administrative_area_level_1':
                        stateAbbrInput.value = component.short_name;
                        break;
                }
            });
        }
    } catch (error) {
        console.error('Error fetching location details:', error);
    }
}
